class FacetFiltersForm extends HTMLElement {
	constructor() {
		super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this), this.debouncedOnSubmit = debounce((e => {
			this.onSubmitHandler(e)
		}), 500);
		this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
		const e = this.querySelector("#FacetsWrapperDesktop");
		e && e.addEventListener("keyup", onKeyUpEscape)
	}
	static setListeners() {
		window.addEventListener("popstate", (e => {
			const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
			t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1)
		}))
	}
	static toggleActiveFacets(e = !0) {
		document.querySelectorAll(".js-facet-remove").forEach((t => {
			t.classList.toggle("disabled", e)
		}))
	}
	static renderPage(e, t, r = !0) {
		FacetFiltersForm.searchParamsPrev = e;
		const s = FacetFiltersForm.getSections(),
			a = document.getElementById("ProductCount"),
			c = document.getElementById("ProductCountDesktop");
		document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"), a && a.classList.add("loading"), c && c.classList.add("loading"), s.forEach((r => {
			const s = `${window.location.pathname}?section_id=${r.section}&${e}`,
				a = e => e.url === s;
			FacetFiltersForm.filterData.some(a) ? FacetFiltersForm.renderSectionFromCache(a, t) : FacetFiltersForm.renderSectionFromFetch(s, t)
		})), r && FacetFiltersForm.updateURLHash(e)
	}
	static renderSectionFromFetch(e, t) {
		fetch(e).then((e => e.text())).then((r => {
			const s = r;
			FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
				html: s,
				url: e
			}], FacetFiltersForm.renderFilters(s, t), FacetFiltersForm.renderProductGridContainer(s), FacetFiltersForm.renderProductCount(s)
		}))
	}
	static renderSectionFromCache(e, t) {
		const r = FacetFiltersForm.filterData.find(e).html;
		FacetFiltersForm.renderFilters(r, t), FacetFiltersForm.renderProductGridContainer(r), FacetFiltersForm.renderProductCount(r)
	}
	static renderProductGridContainer(e) {
		document.getElementById("ProductGridContainer").innerHTML = (new DOMParser).parseFromString(e, "text/html").getElementById("ProductGridContainer").innerHTML
	}
	static renderProductCount(e) {
		const t = (new DOMParser).parseFromString(e, "text/html").getElementById("ProductCount").innerHTML,
			r = document.getElementById("ProductCount"),
			s = document.getElementById("ProductCountDesktop");
		r.innerHTML = t, r.classList.remove("loading"), s && (s.innerHTML = t, s.classList.remove("loading"))
	}
	static renderFilters(e, t) {
		const r = (new DOMParser).parseFromString(e, "text/html"),
			s = r.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),
			a = e => {
				const r = t ? t.target.closest(".js-filter") : void 0;
				return !!r && e.dataset.index === r.dataset.index
			},
			c = Array.from(s).filter((e => !a(e))),
			o = Array.from(s).find(a);
		c.forEach((e => {
			document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`).innerHTML = e.innerHTML
		})), FacetFiltersForm.renderActiveFacets(r), FacetFiltersForm.renderAdditionalElements(r), o && FacetFiltersForm.renderCounts(o, t.target.closest(".js-filter"))
	}
	static renderActiveFacets(e) {
		[".active-facets-mobile", ".active-facets-desktop"].forEach((t => {
			const r = e.querySelector(t);
			r && (document.querySelector(t).innerHTML = r.innerHTML)
		})), FacetFiltersForm.toggleActiveFacets(!1)
	}
	static renderAdditionalElements(e) {
		[".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((t => {
			e.querySelector(t) && (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML)
		})), document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()
	}
	static renderCounts(e, t) {
		const r = t.querySelector(".facets__selected"),
			s = e.querySelector(".facets__selected"),
			a = t.querySelector(".facets__summary"),
			c = e.querySelector(".facets__summary");
		s && r && (t.querySelector(".facets__selected").outerHTML = e.querySelector(".facets__selected").outerHTML), a && c && (t.querySelector(".facets__summary").outerHTML = e.querySelector(".facets__summary").outerHTML)
	}
	static updateURLHash(e) {
		history.pushState({
			searchParams: e
		}, "", `${window.location.pathname}${e&&"?".concat(e)}`)
	}
	static getSections() {
		return [{
			section: document.getElementById("product-grid").dataset.id
		}]
	}
	createSearchParams(e) {
		const t = new FormData(e);
		return new URLSearchParams(t).toString()
	}
	onSubmitForm(e, t) {
		FacetFiltersForm.renderPage(e, t)
	}
	onSubmitHandler(e) {
		e.preventDefault();
		const t = document.querySelectorAll("facet-filters-form form");
		if ("mobile-facets__checkbox" == e.srcElement.className) {
			const t = this.createSearchParams(e.target.closest("form"));
			this.onSubmitForm(t, e)
		} else {
			const r = [],
				s = "FacetFiltersFormMobile" === e.target.closest("form").id;
			t.forEach((e => {
				if (s) "FacetFiltersFormMobile" === e.id && r.push(this.createSearchParams(e));
				else if ("FacetSortForm" === e.id || "FacetFiltersForm" === e.id || "FacetSortDrawerForm" === e.id) {
					document.querySelectorAll(".no-js-list").forEach((e => e.remove())), r.push(this.createSearchParams(e))
				}
			})), this.onSubmitForm(r.join("&"), e)
		}
	}
	onActiveFilterClick(e) {
		e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
		const t = -1 == e.currentTarget.href.indexOf("?") ? "" : e.currentTarget.href.slice(e.currentTarget.href.indexOf("?") + 1);
		FacetFiltersForm.renderPage(t)
	}
}
FacetFiltersForm.filterData = [], FacetFiltersForm.searchParamsInitial = window.location.search.slice(1), FacetFiltersForm.searchParamsPrev = window.location.search.slice(1), customElements.define("facet-filters-form", FacetFiltersForm), FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
	constructor() {
		super(), this.querySelectorAll("input").forEach((e => e.addEventListener("change", this.onRangeChange.bind(this)))), this.setMinAndMaxValues()
	}
	onRangeChange(e) {
		this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues()
	}
	setMinAndMaxValues() {
		const e = this.querySelectorAll("input"),
			t = e[0],
			r = e[1];
		r.value && t.setAttribute("max", r.value), t.value && r.setAttribute("min", t.value), "" === t.value && r.setAttribute("min", 0), "" === r.value && t.setAttribute("max", r.getAttribute("max"))
	}
	adjustToValidValues(e) {
		const t = Number(e.value),
			r = Number(e.getAttribute("min")),
			s = Number(e.getAttribute("max"));
		t < r && (e.value = r), t > s && (e.value = s)
	}
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const e = this.querySelector("a");
		e.setAttribute("role", "button"), e.addEventListener("click", this.closeFilter.bind(this)), e.addEventListener("keyup", (e => {
			e.preventDefault(), "SPACE" === e.code.toUpperCase() && this.closeFilter(e)
		}))
	}
	closeFilter(e) {
		e.preventDefault();
		(this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(e)
	}
}
customElements.define("facet-remove", FacetRemove);